import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=645b0a20&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=645b0a20&prod&scoped=true&lang=css"
import style1 from "./EmojiPicker.vue?vue&type=style&index=1&id=645b0a20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b0a20",
  null
  
)

export default component.exports